import { Scale } from 'lucide-react';
import { GradeBadge } from '../../components/GradeBadge';
import { pct, usdT } from '../../lib/format';
import type { RunResult } from '../../types/api';

/** Headline = lowest breakeven hydroxide price (BR-003), never a single "winner" when options are tied. */
export function VerdictBanner({ run }: { run: RunResult }) {
  const v = run.verdict;
  const best = run.results.find((r) => r.key === v.lowest_breakeven_key) ?? run.recommended;
  const gap = v.lowest_breakeven_usd_t != null && v.benchmark_lioh_usd_t != null ? v.lowest_breakeven_usd_t - v.benchmark_lioh_usd_t : null;
  return (
    <section className="verdict" aria-label="Verdict">
      <div className="verdict-main">
        <p className="eyebrow">Lowest breakeven hydroxide price</p>
        <div className="verdict-figure">
          <strong>{usdT(v.lowest_breakeven_usd_t)}</strong>
          <span>{best.location_name} · {best.route_name}</span>
          <GradeBadge grade={best.confidence.worst} withLabel title="Worst grade among the inputs behind this number" />
        </div>
        {gap != null && (
          <p className={`verdict-gap ${gap > 0 ? 'bad' : 'good'}`}>
            {gap > 0 ? `${usdT(gap)} above` : `${usdT(-gap)} below`} the {usdT(v.benchmark_lioh_usd_t)} benchmark
            {' · '}{v.n_clearing_hurdle} of {v.n_options} options clear the {pct(v.hurdle_rate, 0)} hurdle
          </p>
        )}
      </div>
      <div className="verdict-side">
        <p>{v.statement}</p>
        {run.ties.map((t) => (
          <div className="tie-note" key={t.group} style={{ borderColor: '#f59e0b', background: '#fffbeb', color: '#92400e' }}>
            <Scale size={15} aria-hidden style={{ color: '#d97706', flexShrink: 0, marginTop: 2 }} />
            <span><strong>Statistical Tie Notice:</strong> {t.statement}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
